import { SVGIconComponent } from '../types';

export const nightlight: SVGIconComponent = ({ title = '', ...props }) => (
  <svg data-dir="ltr" viewBox="0 0 11 14" {...props}>
    <title>{title}</title>
    <path d="M7.167.333c1.213 0 2.353.334 3.333.9A6.651 6.651 0 0 0 7.167 7a6.651 6.651 0 0 0 3.333 5.767c-.98.566-2.12.9-3.333.9A6.67 6.67 0 0 1 .5 7 6.67 6.67 0 0 1 7.167.333Z" />
  </svg>
);
